module.exports = __webpack_public_path__ + "static/media/itau.f6dab0b9.svg";